import { render, staticRenderFns } from "./ordendecompra.vue?vue&type=template&id=cd7c41ea"
import script from "./ordendecompra.vue?vue&type=script&lang=js"
export * from "./ordendecompra.vue?vue&type=script&lang=js"
import style0 from "./ordendecompra.vue?vue&type=style&index=0&id=cd7c41ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports